import { Grid, Box, IconButton, Divider } from '@mui/material'
import React from 'react'
import { DefaultPainel, BaseAutoComplete } from '../../components/shared'
import DashBoardModal from '../dashboard/components/DashBoardModal'
import GestaoDatagrid from './styles/GestaoDatagrid'
import DashboardChart from '../../components/charts/dashboard'
import AdaptativeGridContainer from '../../components/shared/AdaptativeGridContainer'
import GestaoDataCard from './components/GestaoDataCard'
import { RemoveRedEye } from '@mui/icons-material'
import PrivateRC from '../../components/PrivateRC'
import gerarPaginacao from '../../services/pagination'
import TableHeader from '../../components/shared/tables/TableHeader'
import BaseFloatFilter from '../../components/BaseFloatFilter'
import filter from './filters'
import Dater from '../../services/DateFormat'
import TipoPostagem from '../../components/charts/tipoPostagem'
import YearFilter from './components/YearFilter'
import CardMaiorNumeroPaginas from './components/CardMaiorNumeroPaginas'
import CardLivroMaisLido from './components/CardLivroMaisLido'
import CardMaiorNumeroDeLivros from './components/CardMaiorNumeroDeLivros'
import CardCategoriaMaisLida from './components/CardCategoriaMaisLida'

import { useGestaoDashboard } from '../../hooks/useGestaoDashboard'

const DashBoardGestao = () => {
  const {
    ranking,
    tipoPostagem,
    categoriasPostagens,
    filters,
    tableLoading,
    openModal,
    obraId,
    handleFilterChange,
    handleMesChange,
    handleAnoChange,
    handlePageChange,
    handleOpenModal,
    handleCloseModal
  } = useGestaoDashboard()

  const meses = Dater().meses

  const columns = [
    { field: 'obra_titulo', headerName: 'Livro', flex: 4 },
    {
      field: 'count_postagem_id',
      type: 'number',
      headerName: 'Quantidade',
      flex: 2
    },
    {
      headerName: 'Ações',
      field: '',
      flex: 1.4,
      renderCell: ({ row }) => {
        return (
          <IconButton
            color="leitura"
            onClick={() => handleOpenModal(row.id)} // Usa o handler
          >
            <RemoveRedEye />
          </IconButton>
        )
      }
    }
  ].map(item => ({
    ...item,
    headerClassName: 'styledHeader',
    sortable: false
  }))

  const pagination = gerarPaginacao(
    true,
    ranking.lastPage,
    ranking.currentPage,
    handlePageChange // Usa o handler
  )

  return (
    <Box sx={{ mt: 5 }}>
      <DashBoardModal
        open={openModal}
        obraId={obraId}
        filters={filters}
        onClose={handleCloseModal}
      />
      <BaseFloatFilter
        onChange={handleFilterChange}
        filter={filter}
        filters={filters}
        components={
          <>
            <YearFilter
              value={filters.ano_id ? new Date(filters.ano_id, 0, 1) : null} // Constrói o valor
              onChange={handleAnoChange}
              onClear={() => handleAnoChange(undefined)}
            />
            <div style={{ marginTop: '1rem' }}>
              <BaseAutoComplete
                list={meses}
                key="id" // Assumindo que a lista de meses tem 'id'
                listLabel={'nome'}
                value={meses.find(m => m.id === filters.mes_id) || null} // Controla o valor
                inputProps={{ label: 'Mês' }}
                onChange={handleMesChange}
              />
            </div>
          </>
        }
      />
      <AdaptativeGridContainer
        sx={{ display: 'flex', justifyContent: 'space-between !important' }}
      >
        <GestaoDataCard filters={filters} />
      </AdaptativeGridContainer>
      <AdaptativeGridContainer
        sx={{
          justifyContent: 'space-between'
        }}
      >
        <Grid item xs={12} sm={5.9} sx={{ mt: 2 }}>
          <CardMaiorNumeroPaginas filters={filters} />
        </Grid>
        <Grid item xs={12} sm={5.9} sx={{ mt: 2 }}>
          <CardLivroMaisLido filters={filters} />
        </Grid>
        <Grid item xs={12} sm={5.9} sx={{ mt: 2 }}>
          <CardMaiorNumeroDeLivros filters={filters} />
        </Grid>
        <Grid item xs={12} sm={5.9} sx={{ mt: 2 }}>
          <CardCategoriaMaisLida filters={filters} />
        </Grid>
      </AdaptativeGridContainer>
      <PrivateRC permission="bibliotecas#list-all">
        <AdaptativeGridContainer
          sx={{
            mt: 2,
            justifyContent: 'space-between'
          }}
        >
          <>
            <Grid item xs={12} sm={5.9} sx={{ mt: 2, mb: 2 }}>
              <DefaultPainel>
                <TableHeader titulo="Ranking de Leituras" />
                <Divider />
                <GestaoDatagrid
                  styles={{ height: '52vh' }}
                  rows={ranking.data} // Usa os dados do hook
                  columns={columns}
                  disableColumnMenu
                  pagination={pagination}
                  loading={tableLoading} // Usa o loading do hook
                />
              </DefaultPainel>
            </Grid>
            <Grid item xs={12} sm={5.9} sx={{ mt: 2, mb: 2 }}>
              <DefaultPainel sx={{ bg: 'red', height: '62vh' }}>
                <TableHeader titulo="Tipo de postagem" />
                <TipoPostagem postagens={tipoPostagem} filters={filters} />{' '}
                {/* Usa dados do hook */}
              </DefaultPainel>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              sx={{ marginTop: { xs: '1.5vh', sm: '1.5h', md: '1.5vh' } }}
            >
              <DefaultPainel sx={{ p: 1.7 }}>
                <TableHeader titulo="Categoria de Leitura" />
                <DashboardChart postagens={categoriasPostagens} />{' '}
                {/* Usa dados do hook */}
              </DefaultPainel>
            </Grid>
          </>
        </AdaptativeGridContainer>
      </PrivateRC>
    </Box>
  )
}
export default DashBoardGestao
